/* eslint-disable prefer-destructuring */
// envs
export const FRETEBRAS_LOGOUT_URL = process.env.FRETEBRAS_LOGOUT_URL;
export const GR_BFF_URL = process.env.GR_BFF_URL;
export const NCA_BFF_URL = process.env.NCA_BFF_URL;

// redirect URLs
export const FREIGHT_LIST_URL = '/meus-fretes';
export const NOT_FOUND_URL = '/404';
export const RISK_MANAGEMENT_LISTING_URL = '/gestao-de-risco';

// end-point URLs
export const COMPANY_TERMS_URL = 'companies/{companyId}/accept-terms';
export const ACCEPT_TERMS_URL = 'risk-management/accept-terms';
export const SEND_RESPONSABLE_URL = 'contact/hubspot';
export const FEATURE_TOGGLE_URL = 'company/features-access';
export const USER_DATA_URL = 'user/me';

// chat bot
export const CHAT_ICON_URL =
  'https://9020753.fs1.hubspotusercontent-na1.net/hubfs/9020753/Imported%20images/avatar%203.jpg';
export const CHAT_CLOSE_ICON_URL = 'https://fs.hubspotusercontent00.net/hubfs/9020753/chats/atendente_13.jpeg';

// State keys
export const PROJECT_RECOIL_KEY = 'riskManagementOnboarding';
export const AUTH_STATE = 'auth';
export const FEATURE_TOGGLE_STATE = 'featureToggle';
export const IS_LOADED_STATE = 'isLoadedState';
export const LEARN_MORE_MODAL_STATE = 'learnMoreModal';
export const ONBOARDING_STATE = 'onboarding';
export const SECTION_STATE = 'section';
export const TOAST_STATE = 'toast';

// other
export const FEATURE_NAME = 'risk_management';
export const AUTHORIZATION_KEY = '_TOKEN_BFF';
export const PORTAL = 'portal-risk-management-onboarding';
